export default {
  restaurantabout2: {
    subtitle: "للمطاعم",

    title1: "اطلب بذكاء",
    title2: "أنفق أقل",

    desc:
      "تساعد MAHAL المطاعم على تبسيط عمليات التوريد من خلال ربطها مباشرة بالموردين الموثوقين للتوريد اليومي وبالكميات الكبيرة.",

    text:
      "تعمل MAHAL مع شبكة واسعة من الموردين — من المزارع المحلية إلى الموزعين الكبار — لضمان حصول المطاعم دائمًا على مكونات عالية الجودة وأسعار عادلة وتوريد موثوق على المدى الطويل من خلال منصة واحدة.",

    li1: "وصول مباشر إلى الموردين الموثوقين",
    li2: "أسعار شفافة وتنافسية",
    li3: "طلبات يومية وبكميات كبيرة في مكان واحد",
    li4: "تتبع الطلبات وإدارة التوصيل",

    btn1: "الدخول إلى بوابة المطعم",
    btn2: "عرض العروض الحالية",
  },
};